import React from 'react';
import AgoraRTC, { AgoraRTCProvider } from 'agora-rtc-react';

// Create the client OUTSIDE the component so it doesn't recreate on every render
const agoraClient = AgoraRTC.createClient({ mode: 'live', codec: 'vp8' });

export const LiveStreamWrapper = ({ children }: { children: React.ReactNode }) => {
  return (
    <AgoraRTCProvider client={agoraClient}>
      {children}
    </AgoraRTCProvider>
  );
};